import type { ReactNode, RefObject } from 'react';
import { useEffect, useRef } from 'react';

import { BaseRteIntroOutroText } from './BaseRteIntroOutro.styled';

type Props = {
  holderRef: RefObject<HTMLDivElement | null>;
  top?: number;
  right?: number;
  bottom?: number;
  children: ReactNode;
  offesetVariable: string;
  qaId: string;
};

export function BaseRteIntroOutro({
  holderRef,
  top,
  right = 0,
  bottom,
  children,
  offesetVariable,
  qaId,
}: Props) {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const holder = holderRef.current;
    if (!holder) return;

    holder.style.setProperty(
      offesetVariable,
      `${elementRef.current?.offsetHeight ?? 0}px`,
    );
  }, [holderRef, offesetVariable]);

  return (
    <div
      ref={elementRef}
      data-qa-id={qaId}
      style={{ position: 'absolute', left: 0, right, top, bottom }}
    >
      <BaseRteIntroOutroText>{children}</BaseRteIntroOutroText>
    </div>
  );
}
